import styled from 'styled-components';

import { PageContainer } from 'shared-components/state-views/styled-components';
import { SYNMATCH_COLORS } from 'theme';

export const FallbackShell = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${SYNMATCH_COLORS.surface.default};
`;

export const FallbackHeader = styled.header`
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 0.0625rem solid ${SYNMATCH_COLORS.border.default};
`;

export const FallbackMain = styled(PageContainer)`
  flex: 1;
`;
